import React, { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { Button, EmailInput } from '@fhs/ui';
import { isEmailValid } from '@fhs/ui/src/components/form-text-inputs/masks';

import { useAuthScroll } from '../auth-scroll-context';
import { useCreateOtp } from '../hooks';
import { AuthIdentifiers } from '../types';

export const ContinueWithEmail = () => {
  const { scrollToTop } = useAuthScroll();
  const { createOtp, otpLoading } = useCreateOtp();
  const [loginIdentifier, setLoginIdentifier] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const onInputChange = useCallback(
    input => {
      setLoginIdentifier(input);
      setError(false);
    },
    [setLoginIdentifier, setError]
  );

  const attemptLogin = useCallback(async () => {
    if (isEmailValid(loginIdentifier)) {
      await createOtp({
        loginIdentifier,
        identifierType: AuthIdentifiers.EMAIL,
      });
    } else {
      setError(true);
      scrollToTop();
    }
  }, [createOtp, loginIdentifier, scrollToTop]);
  return (
    <View style={{ width: '100%', gap: 24 }}>
      <View>
        <EmailInput
          label="Email Address"
          value={loginIdentifier}
          onChange={onInputChange}
          error={error ? 'Please enter a valid email' : ''}
          autoFocus
          readOnly={otpLoading}
          onSubmitEditing={attemptLogin}
        />
      </View>
      <Button
        size="md"
        style={styles.continueButton}
        onPress={attemptLogin}
        loading={otpLoading}
        disabled={otpLoading}
      >
        <Button.Text>Continue</Button.Text>
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  continueButton: {
    height: 48,
    width: '100%',
    alignSelf: 'center',
  },
});
